import { Box, List, ListItem, Tooltip, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from "react";
import { useLingui } from "@lingui/react";
import { msg } from "@lingui/macro";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { IconButton } from "@mui/material/";
import { Remove } from "@mui/icons-material";
import httpReq from "../../ce-services/http-req";

const ThirdPage = ({ isMobile, vehicleTypes, rowsData, setRowsData, pageIndex, setPageIndex, draft, setDraft }) => {
  const { _ } = useLingui();


  const [vehicleTypesPage, setVehicleTypesPage] = useState(vehicleTypes);

  const getVehicleTypes = async () => {
    const res = await httpReq('VehicleType/GetList', 'GET', null, false);
    if (!res.responseAnyError) {
      const mappedWithAdmount = res.responseData.map((vehicle) => {
        vehicle.admount = 0;
        return vehicle;
      });
      localStorage.setItem('vehicleTypes', JSON.stringify(mappedWithAdmount));

      setVehicleTypesPage(mappedWithAdmount);
    }
  };

  const verifyAndNext = () => {
    const draftVehicleType = { publicAccidentVehicleTypes: vehicleTypesPage };
    const dt = Object.assign(draft, draftVehicleType);

    setDraft(dt);
    setPageIndex(pageIndex + 1);
  };

  const manageVehicleQnt = (vehicle, operation) => {
    const v = [...vehicleTypesPage];
    const idx = v.findIndex((vehicleType) => vehicleType.id === vehicle.id);
    if (operation === '-') {
      v[idx].admount -= 1;
    } else {
      v[idx].admount += 1;
    }
    setVehicleTypesPage(v);
  };


  const isNextDisabled = !vehicleTypesPage.some((vehicleType) => vehicleType.admount > 0);

  return (
    <>
            <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', flex: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 4, padding: 4 }}>

                    <Box>
                        <Tooltip title={_(msg`Previous`)}>
                            <IconButton onClick={() => {
                setPageIndex(pageIndex - 1);
              }} variant="contained">
                                <ChevronLeftIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={_(msg`Next`)}>
                            <IconButton disabled={isNextDisabled} onClick={() => verifyAndNext()} variant="contained">
                                <NavigateNextIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                    <Box sx={{
            width: isMobile ? '80%' : '30%',
            maxHeight: isMobile ? 500 : 600,
            display: 'flex',
            flexDirection: 'column',
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px;'
          }}>
                        <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              padding: 2,
              backgroundColor: '#5cbec4',
              borderBottom: '1px solid lightgrey'
            }}>
                            <Typography sx={{ fontWeight: 700, color: 'white' }}>{_(msg`Select involved vehicles`)}</Typography>
                        </Box>
                        <List sx={{ display: 'flex', overflowY: 'auto', flexDirection: 'column', flex: 1 }}>
                            {vehicleTypesPage.map((vehicle) => {

                return (
                  <ListItem
                    sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <Typography>{vehicle.name}</Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                                            <IconButton disabled={vehicle.admount === 0} onClick={() => {
                        manageVehicleQnt(vehicle, '-');
                      }}>
                                                <Remove />
                                            </IconButton>
                                            <Typography>{vehicle.admount}</Typography>
                                            <IconButton onClick={() => {
                        manageVehicleQnt(vehicle, '+');
                      }}>
                                                <AddIcon />
                                            </IconButton>
                                        </Box>
                                    </ListItem>);

              })}
                        </List>
                    </Box>
                </Box>
            </Box>
        </>);

};
export default ThirdPage;

/*
      <Box sx={{ padding: 4 }}>
<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 4}}>
    <Tooltip title={_(msg`Previous`)}>
        <IconButton onClick={() => {
            setPageIndex(pageIndex - 1)
        }} variant="contained" >
            <ChevronLeftIcon/>
        </IconButton>
    </Tooltip>
    <Tooltip title={_(msg`Next`)}>
        <IconButton disabled={rowsData.length === 0} onClick={() => verifyAndNext()} variant="contained">
            <NavigateNextIcon/>
        </IconButton>
    </Tooltip>
</Box>
{!isMobile &&
<Toolbar sx={{ display: 'flex', flexDirection: 'row' }}>
    <InputLabel id="select-vehicle-label">Vehicle type</InputLabel>
    <Select
        sx={{ display: 'flex', flex: 1, width: '50vw', margin: 2 }}
        labelId='select-vehicle-label'
        value={selectedSingleVehicle}
        onChange={(e) => { setSelectedSingleVehicle(e.target.value) }}
    >
        {vehicleTypes.map((vehicle, k) => {
            return (
                <MenuItem key={k} value={vehicle}>{vehicle.name}</MenuItem>
            )
        })}
    </Select>
    <Button sx={{ display: 'flex', flex: 0.5 }} disabled={!selectedSingleVehicle} onClick={() => {
        const rows = [...rowsData]
        const idx = rows.findIndex(r => {
            return r.id === selectedSingleVehicle.id
        })
        if (idx === -1) {
            selectedSingleVehicle.admount = 1
            rows.push(selectedSingleVehicle)
            setRowsData(rows)
            setSelectedSingleVehicle(null)
        }
    }} variant='contained'>Add <AddIcon /></Button>
</Toolbar>
}

{isMobile &&
<Grid container>
    <Grid item xs={12}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <InputLabel sx={{ display: 'flex', flex: 0.5 }} id="select-vehicle-label">Vehicle type</InputLabel>
            <Select
                sx={{ display: 'flex', flex: 1, margin: 2 }}
                labelId='select-vehicle-label'
                value={selectedSingleVehicle}
                onChange={(e) => { setSelectedSingleVehicle(e.target.value) }}
            >
                {vehicleTypes.map((vehicle, k) => {
                    return (
                        <MenuItem key={k} value={vehicle}>{vehicle.name}</MenuItem>
                    )
                })}
            </Select>
        </Box>
    </Grid>
    <Grid item xs={12}>
        <Button sx={{ display: 'flex', flex: 1, marginBottom: 2, width: '100%' }} disabled={!selectedSingleVehicle} onClick={() => {
            const rows = [...rowsData]
            const idx = rows.findIndex(r => {
                return r.id === selectedSingleVehicle.id
            })
            if (idx === -1) {
                selectedSingleVehicle.admount = 1
                rows.push(selectedSingleVehicle)
                setRowsData(rows)
                setSelectedSingleVehicle(null)
            }
        }} variant='contained'>Add <AddIcon /></Button>
    </Grid>
</Grid>
}
<Typography variant="h8" sx={{ marginBottom: 1 }}>Tap under <strong style={{fontStyle:'oblique'}}>Quantity</strong> to select number of vehicles per type</Typography>
<div style={{ height: '60vh' }}>
    <AgGridReact modules={[ClientSideRowModelModule, NumberEditorModule, ValidationModule]} columnDefs={colsLabel} rowData={rowsData} />
</div>

</Box>


 */